import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=2125b498&scoped=true&lang=pug"
import script from "./queue.vue?vue&type=script&lang=js"
export * from "./queue.vue?vue&type=script&lang=js"
import style0 from "./queue.vue?vue&type=style&index=0&id=2125b498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125b498",
  null
  
)

export default component.exports